module.exports = __webpack_public_path__ + "static/media/close-up.47b80e48.svg";